module.exports = __webpack_public_path__ + "img/inktober_2020_07_fancy.6e0d3d82.jpg";